import React, { Suspense } from "react";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { useState, useRef, useEffect, useLayoutEffect } from "react";
import useFetch from "../../../../utils/useFetch";
import { Box, TextField, Select, MenuItem ,CircularProgress} from "@mui/material";
import Grid from "@mui/material/Grid";
import { experimentalStyled as styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import EmailTemplate from "./EmailTemplate";
import Backdrop from '@mui/material/Backdrop';
import { useNavigate } from "react-router-dom";




const ITEM_HEIGHT = 50;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
            width: 200,
        },
    },
};
export default function EmailtemplateList({
    handleClose1,
    firstPqClient,
    PqClients,
}) {
    const params = new URLSearchParams(window.location.search);
    const PQID = params.get("pqid");
    const Type = params.get("Type");

    const [EmailtemplateLists, setEmailtemplateLists] = useState([]);
    const [ClientId, setClientId] = useState(firstPqClient);
    const [loader, setloader] = useState(true);
    const [searchParam] = useState(["text"]);
    const [ser1, setSer1] = useState("");
    const { data: res } = useFetch(
        "Prequalification/GetEmailTemplatesList?pqId=" + PQID + "&clientId=" + ClientId
    );
    useEffect(() => {
        if (res?.data) {
            setEmailtemplateLists(res?.data);
            setloader(false)
        }
    }, [res]);
    function search(EmailtemplateLists) {
        return EmailtemplateLists.filter((item) => {
            return searchParam.some((newItem) => {
                return (
                    item[newItem].toString().toLowerCase().indexOf(ser1.toLowerCase()) >
                    -1
                );
            });
        });
    }
    const [view, setView] = useState(true);
    const [TempId, setTempId] = useState("");

    const Viewed = (r) => {
        setTempId(r?.value);
        setView((view) => !view);
    };

    const SelectClientHandle = (e) => {
        setClientId(e);

    }
    const navigate = useNavigate();
    const handleClose = () => {
        navigate("/DashBoard");

    }
    console.log(window.location.pathname);
  
    
    return (
        <div>
                <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      
      >
        <CircularProgress color="inherit" />
      </Backdrop>
            <AppBar sx={{ position: "fixed", backgroundColor: "#1976d2"}}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={window.location.pathname==="/EmailTemplateList"?handleClose:handleClose1}
                        aria-label="close"
                        sx={{ color: "#fff" }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <Typography
                        sx={{ ml: 2, flex: 1, color: "#fff" }}
                        variant="h6"
                        component="div"
                    >
                        {view ? " Email Templates list" : "Send Email"}
                    </Typography>

                    <TextField
                        placeholder="Search..."
                        sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            backgroundColor: "#fff",
                            display: !view ? "none" : "",
                        }}
                        variant="outlined"
                        size="small"
                        value={ser1}
                        onChange={(e) => setSer1(e.target.value)}
                    />
                </Toolbar>
            </AppBar>
            <br />
            <br />
            <br />
            <div style={{ marginLeft: "20px", display: PqClients?.length > 1? "block" : "none"  }} hidden={!view}>

               
                <span style={{ color: "#3E4A62" }}>
                    Select Client<small style={{ color: "red" }}>*</small>
                </span>
                <br />
                <Select
                    sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px",
                    }}
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    size="small"
                    value={ClientId}
                    onChange={(e) => SelectClientHandle(e.target.value)} // input={<OutlinedInput label="SelectClient" />}
                    MenuProps={MenuProps}
                >
                    {PqClients?.map((item, index) => (
                        <MenuItem key={index} value={item.key}>
                            {item.value}
                        </MenuItem>
                    ))}
                </Select>
            </div>

            <List sx={{ display: !view ? "none" : "" }}>
                {search(EmailtemplateLists).map((r,index) => (
                    <ListItem key={index}>
                        <ListItemText onClick={() => Viewed(r)} key={r.value} sx={{ color: "#1976d2" ,cursor: "pointer" }}>
                            <MailOutlineIcon /> {r.text}
                        </ListItemText>
                    </ListItem>
                ))}
            </List>


            {!view && <EmailTemplate ClientId={ClientId} TEMPID={TempId} remote={Viewed} PQID={PQID}  handleClose1={handleClose1}/>}
        </div>
    );
}